// The sender's message and sign-by deadline on a workflow: the same rules as
// the backend's `WorkflowNotice` (app/modules/workflow/schemas/workflow.py).

export const MAX_MESSAGE_LENGTH = 2000;
export const DEADLINE_MAX_YEAR = 2100;

const pad = (n) => String(n).padStart(2, '0');

/** A time as a `datetime-local` value, in the browser's own zone ('' when none). */
export function toLocalInput(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Why a typed deadline is refused: 'invalid' | 'past' | 'too_late' | null. Blank = no deadline. */
export function deadlineProblem(value, now = new Date()) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return 'invalid';
  if (d.getFullYear() > DEADLINE_MAX_YEAR) return 'too_late';
  if (d <= now) return 'past';
  return null;
}

/** The request fields: the message trimmed (blank = none), the deadline in UTC. */
export function noticePayload({ message, expiresAt }) {
  const text = (message || '').trim();
  return {
    message: text || null,
    expires_at: expiresAt ? new Date(expiresAt).toISOString() : null,
  };
}
